import { getLanguageStore } from '../utils/storage/language'

import zh from "./zh"
import en from './en'
import th from './th'


export const getCurrLang = (lang) => {
    const { language } = navigator
    const storeLan = getLanguageStore()
    const lan = (storeLan || language).substring(0, 2)

    return lan
};

export const locales = {
    'zh': zh,
    'en': en,
    'th': th,
}

export const getCurLocale = (lan) => {
    const key = getCurrLang(lan)
    return locales[key] || locales['en']
}